<template>
<div class="size-picker" v-if="product">
    <div class="size-main-header">
      <h2 class="size-main-title">Size</h2>
      <img class="size-arrow" src="@/assets/img/arrow_down.svg" alt="" />
    </div>
    <div class="size-type">
      <div class="size-card-container">
        <SizeSelectorCard v-for="(variations, index) of product.product_variations" :key="`size-${index}`" :sizes="variations" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ProductState } from './state'
import SizeSelectorCard from './SizeSelectorCard.vue'
const { product } = ProductState()

// console.log(product.value)

</script>
<style lang="scss" scoped>

.size-picker {
    @apply ml-0 lg:ml-28;
    .size-main-header {
      @apply flex items-center gap-4 mt-8 mb-4;
      .size-main-title {
        @apply text-[28px] md:text-[32px] text-ore_green_dark;
      }
      .size-arrow {
        @apply w-5 h-5 md:w-6 md:h-6;
      }
    }
    .size-type {
      @apply bg-[#D9E5DD] rounded-2xl p-6 lg:p-8 shadow-md;
      .size-card-container {
        @apply grid grid-cols-1 gap-4;
      }
    }
  }
</style>
